export default "__VITE_ASSET__DYci6XQw__"